<template>
  <div>
    <div class="marTML" style="background:#f4f4f4; border-top:2px solid #ddd;">
      <div class="widM fntH4 bold padTS padBS" style="color:#2c2c2c;">액티비티 예약</div>
    </div>

    <div class="widM txtC marTML">
      <a @click="openActivityPopup" class="disIb fntH5 bold NCACroa_arrow" style="background:#20893d; color:#fff;">
        액티비티 정보 안내 &nbsp;
        <img src="@/views/survey/images/NCACroatia_arrow.png" alt="" style="max-width:10px; width:2%; vertical-align: baseline;">
      </a>
      <p class="fntE txtL marTSM" style="color:#d91734;">* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다.</p>
    </div>

    <hr class="marTML" style="border-top:1px solid #ddd">

    <template v-for="(activity, sq_code, i) in activities">
      <SurveyActivity
        :key="`activity_${sq_code}`"
        :activity="activity"
        :seq="i"
      />
      <hr
        v-if="i < activityCount - 1"
        :key="`hr_${activity.sq_code}`"
        style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { SURVEY, ACTIVITY_QUESTIONS } from '@/store/actions/survey'
import { mapGetters } from 'vuex'
import SurveyActivity from './SurveyActivity.vue'

export default {
  name: 'SurveyActivityList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivity,
  },
  computed: {
    ...mapGetters(SURVEY, {
      activities: ACTIVITY_QUESTIONS
    }),
    activityCount() {
      return Object.keys(this.activities).length;
    }
  },
  methods: {
    openActivityPopup() {
      this.openPopupLayer({
        showHeader: false,
        showConfirmBtn: true
      });
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyActivityList.vue